const splashscreenHiddenClassName = 'splashscreen__hidden';
const splashScreenElementId = 'splashscreen';

const getSplashscreenEl = () => document.getElementById(splashScreenElementId);

export const showSplashscreen = () => getSplashscreenEl()?.classList.remove(splashscreenHiddenClassName);
export const hideSplashscreen = () => getSplashscreenEl()?.classList.add(splashscreenHiddenClassName);
